import { prodFirebase, stagingFirebase } from './config/firebase'
import {
  productionSentry,
  stagingSentry,
  developmentSentry,
  localSentry,
} from './config/sentry'

export const isBrowser = typeof window !== 'undefined'

const environmentHostMap = {
  'localhost:8000': 'local',
  'shopq-dev.qsciences.com': 'development',
  'shopq-88634-dev.web.app': 'development',
  'shopq-staging.qsciences.com': 'staging',
  'shopq-88634-staging.web.app': 'staging',
  'shopq-88634-preproduction.web.app': 'preproduction',
  'shopq.azurewebsites.net': 'production',
  'insynq.qsciences.com': 'production',
  'shopq.qsciences.com': 'production',
  'shopq-88634.web.app': 'production',
  'shopq-88634-ownerstour-production.web.app': 'eventProduction',
  'ownerstour.qsciences.com': 'eventProduction',
}

const environments = {
  production: {
    QSERVICES_API_URL: 'https://qservicesapi.azurewebsites.net/graphql',
    MAGENTO_API_URL: 'https://mcprod.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=production',
    NEXIO_URL: 'https://api.nexiopay.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: prodFirebase,
    SENTRY: productionSentry,
    ENV: 'production',
    GOOGLE_ANALYTICS_ID: 'G-JQQ2426NQ3',
    IS_EVENT_SITE: false,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  preproduction: {
    QSERVICES_API_URL: 'https://qservicesapi.azurewebsites.net/graphql',
    MAGENTO_API_URL: 'https://mcstaging2.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=preproduction',
    NEXIO_URL: 'https://api.nexiopay.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: prodFirebase,
    SENTRY: productionSentry,
    ENV: 'preproduction',
    GOOGLE_ANALYTICS_ID: 'G-JQQ2426NQ3',
    IS_EVENT_SITE: false,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  staging: {
    QSERVICES_API_URL: 'https://qservices-staging.qsciences.com/graphql',
    MAGENTO_API_URL: 'https://mcstaging.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=staging',
    NEXIO_URL: 'https://api.nexiopaysandbox.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: stagingFirebase,
    SENTRY: stagingSentry,
    ENV: 'staging',
    GOOGLE_ANALYTICS_ID: 'G-8V6XJ2G77B',
    IS_EVENT_SITE: false,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  development: {
    QSERVICES_API_URL: 'https://qservices-dev.qsciences.com/graphql',
    MAGENTO_API_URL: 'https://mcstaging.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=staging',
    NEXIO_URL: 'https://api.nexiopaysandbox.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: stagingFirebase,
    SENTRY: developmentSentry,
    ENV: 'development',
    GOOGLE_ANALYTICS_ID: 'G-8V6XJ2G77B',
    IS_EVENT_SITE: false,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  eventProduction: {
    QSERVICES_API_URL: 'https://qservicesapi.azurewebsites.net/graphql',
    MAGENTO_API_URL: 'https://mcprod.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=production',
    NEXIO_URL: 'https://api.nexiopay.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: prodFirebase,
    SENTRY: productionSentry,
    ENV: 'eventProduction',
    GOOGLE_ANALYTICS_ID: 'G-SDVBZEL01B',
    IS_EVENT_SITE: true,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  eventStaging: {
    QSERVICES_API_URL: 'https://qservices-staging.qsciences.com/graphql',
    MAGENTO_API_URL: 'https://mcstaging.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=staging',
    NEXIO_URL: 'https://api.nexiopaysandbox.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: stagingFirebase,
    SENTRY: stagingSentry,
    ENV: 'eventStaging',
    GOOGLE_ANALYTICS_ID: 'G-8V6XJ2G77B',
    IS_EVENT_SITE: true,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
  local: {
    QSERVICES_API_URL: 'https://qservices-dev.qsciences.com/graphql',
    MAGENTO_API_URL: 'https://mcstaging.qsciences.com/graphql',
    AZURE_CUSTOMERGROUP_FUNCTION:
      'https://qsazurefunctions.azurewebsites.net/api/updatemagentocustomergroup?code=PTaXE1yO9LuZdDgMKb0DjwcDnPtpG3pNcghts3ZDVVKRkvh%2FL8gsKQ%3D%3D&environment=staging',
    NEXIO_URL: 'https://api.nexiopaysandbox.com',
    GOOGLE_MAP_API_KEY: 'AIzaSyC2dPnQc-JjKgW1E8a-QCRdFNFZ4rTuL8k',
    FIREBASE: stagingFirebase,
    SENTRY: localSentry,
    ENV: 'local',
    GOOGLE_ANALYTICS_ID: 'G-8V6XJ2G77B',
    IS_EVENT_SITE: true,
    SLACK_WEBHOOK_URL:
      'https://hooks.slack.com/services/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',
  },
}

/**
 * Determines the environment based on the url of the site. If no match, returns local
 */
const getEnvironment = (host = window.location.host) => {
  const currentEnv = environmentHostMap[host] || 'local'
  return {
    isBrowser,
    ...environments[currentEnv],
  }
}

/**
 * The same as getEnvironment, but safe for builds where the window object does not exist
 */
const getEnvironmentBuildSafe = () => {
  if (isBrowser) return getEnvironment()
  else return {}
}

export default getEnvironmentBuildSafe()
